var React = require('react');

function SocialMail (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M448,6H64A64,64,0,0,0,0,70V326a64,64,0,0,0,64,64H448a64,64,0,0,0,64-64V70A64,64,0,0,0,448,6ZM342.66,176.78,478.12,60.69A30.78,30.78,0,0,1,480,70V326c0,2.22-.84,4.19-1.28,6.28ZM448,38c2.12,0,4,.81,6,1.22L256,208.94,58,39.22c2-.41,3.88-1.22,6-1.22ZM33.27,332.25c-.44-2.09-1.27-4-1.27-6.25V70a30.79,30.79,0,0,1,1.89-9.31L169.31,176.75ZM64,358a31,31,0,0,1-9.12-1.84L193.62,197.59l52,44.53a15.9,15.9,0,0,0,20.82,0l52-44.53L457.12,356.16A30.69,30.69,0,0,1,448,358Z","transform":"translate(0 -6)"}));
}

SocialMail.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 512 384"};

module.exports = SocialMail;

SocialMail.default = SocialMail;
